import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
              <span className="w-8 h-8 flex items-center justify-center text-xl">
                🍉
              </span>
              <span className="text-lg font-heading font-bold text-background-50 whitespace-nowrap">
                火影西瓜
              </span>
            </Link>
            <p className="text-sm text-background-300 leading-relaxed">
              融合火影忍者主题与西瓜创意的爆款玩法平台。解锁忍者风夏日吃瓜新姿势！
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              <a href="#footer-categories">热门分类</a>
            </h4>
            <ul className="space-y-2">
              {categories.slice(0, 5).map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-300 hover:text-accent-400 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              <a href="#footer-quick-links">快速链接</a>
            </h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/"
                  className="text-sm text-background-300 hover:text-accent-400 transition-colors cursor-pointer"
                >
                  首页
                </Link>
              </li>
              <li>
                <Link
                  to="/category/zaoxing-diy"
                  className="text-sm text-background-300 hover:text-accent-400 transition-colors cursor-pointer"
                >
                  造型DIY
                </Link>
              </li>
              <li>
                <Link
                  to="/category/renzhe-diaoke"
                  className="text-sm text-background-300 hover:text-accent-400 transition-colors cursor-pointer"
                >
                  忍者雕刻
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm text-background-300 hover:text-accent-400 transition-colors cursor-pointer"
                >
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              <a href="#footer-contact">联系方式</a>
            </h4>
            <ul className="space-y-2">
              <li className="flex items-center gap-2 text-sm text-background-300">
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-mail-line text-sm"></i>
                </span>
                hello@huoyingxigua.com
              </li>
              <li className="flex items-center gap-2 text-sm text-background-300">
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-wechat-line text-sm"></i>
                </span>
                火影西瓜官方
              </li>
              <li className="flex items-center gap-2 text-sm text-background-300">
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-bilibili-line text-sm"></i>
                </span>
                B站：火影西瓜君
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-700 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-400">
            &copy; {new Date().getFullYear()} 火影西瓜 huoyingxigua.com 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a
              href="#"
              className="text-xs text-background-400 hover:text-background-200 transition-colors"
              rel="nofollow"
            >
              隐私政策
            </a>
            <a
              href="#"
              className="text-xs text-background-400 hover:text-background-200 transition-colors"
              rel="nofollow"
            >
              使用条款
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}